import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const floatingTags = [
  { label: 'ブランディング', color: '#38BDF8', bg: '#E0F7FF', rotate: '-rotate-3', pos: 'top-32 left-16' },
  { label: 'デジタルマーケ', color: '#F472B6', bg: '#FFF0F7', rotate: 'rotate-2', pos: 'top-44 right-20' },
  { label: 'クリエイティブ', color: '#FBBF24', bg: '#FFFBEB', rotate: '-rotate-2', pos: 'bottom-40 left-24' },
  { label: 'PR・広告', color: '#A3E635', bg: '#F3FFEA', rotate: 'rotate-3', pos: 'bottom-48 right-16' },
];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen w-full overflow-hidden flex items-center justify-center">
      {/* BG Image */}
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20colorful%20abstract%20pop%20art%20background%20with%20bold%20geometric%20shapes%2C%20bright%20sky%20blue%20yellow%20pink%20lime%20green%20swirls%20and%20dots%20pattern%2C%20playful%20modern%20design%20studio%20atmosphere%2C%20energetic%20creative%20workspace%20with%20confetti%20and%20stars%2C%20white%20and%20colorful%20gradient%2C%20happy%20joyful%20aesthetic&width=1400&height=900&seq=hero_pop001&orientation=landscape"
        alt="Hero Background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/75 via-white/60 to-white/50" />

      {/* Floating decorative shapes */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-[#38BDF8]/30 rounded-full animate-bounce" style={{ animationDuration: '3s' }} />
      <div className="absolute top-40 right-20 w-14 h-14 bg-[#F472B6]/40 rounded-full animate-bounce" style={{ animationDuration: '2.5s', animationDelay: '0.5s' }} />
      <div className="absolute bottom-32 left-32 w-16 h-16 bg-[#FBBF24]/40 rounded-xl rotate-12 animate-bounce" style={{ animationDuration: '3.5s', animationDelay: '1s' }} />
      <div className="absolute bottom-20 right-32 w-12 h-12 bg-[#A3E635]/50 rounded-full animate-bounce" style={{ animationDuration: '2.8s', animationDelay: '0.3s' }} />
      <div className="absolute top-1/3 left-1/4 w-8 h-8 bg-[#FB923C]/40 rounded-full" />
      <div className="absolute top-2/3 right-1/4 w-10 h-10 bg-[#C084FC]/40 rounded-xl rotate-45" />

      {/* Floating Tags */}
      {floatingTags.map((tag) => (
        <div
          key={tag.label}
          className={`absolute hidden lg:flex items-center gap-1.5 px-4 py-2 rounded-full font-bold text-xs ${tag.rotate} ${tag.pos}`}
          style={{ background: tag.bg, color: tag.color }}
        >
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: tag.color }} />
          {tag.label}
        </div>
      ))}

      {/* Content */}
      <div
        className={`relative z-10 w-full flex flex-col items-center justify-center text-center px-6 transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 mb-8 font-black text-xs" style={{ color: '#F472B6' }}>
          <span className="w-2 h-2 rounded-full bg-[#F472B6] animate-pulse" />
          大阪発・クリエイティブ広告代理店
          <span className="w-2 h-2 rounded-full bg-[#38BDF8] animate-pulse" style={{ animationDelay: '0.5s' }} />
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-gray-900 leading-tight mb-6 max-w-4xl">
          あなたのブランドを、
          <br />
          <span
            className="relative inline-block"
            style={{
              background: 'linear-gradient(135deg, #38BDF8 0%, #F472B6 50%, #FBBF24 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            もっと輝かせよう。
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-gray-600 text-base md:text-lg max-w-xl leading-relaxed mb-10 font-medium">
          Grandeur Architectは、戦略 × クリエイティブで<br className="hidden md:block" />
          あなたのビジネスをもっと楽しく、もっと大きく！
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 items-center mb-14">
          <Link
            to="/contact"
            className="flex items-center gap-2 font-black px-8 py-4 rounded-full whitespace-nowrap cursor-pointer transition-all hover:scale-105 text-white"
            style={{ background: 'linear-gradient(135deg, #38BDF8, #F472B6)' }}
          >
            <i className="ri-mail-send-fill text-lg" />
            お問い合わせ
          </Link>

        </div>


      </div>

      {/* Scroll down */}
      <a
        href="#about"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 cursor-pointer group"
        aria-label="スクロール"
      >
        <span className="text-xs text-gray-400 font-bold group-hover:text-[#38BDF8] transition-colors">SCROLL</span>
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#38BDF8] group-hover:scale-110 transition-transform">
          <i className="ri-arrow-down-line text-white text-sm" />
        </div>
      </a>
    </section>
  );
}
